export default __webpack_public_path__ + "static/media/play_btn.61eb4865.svg";